import { useEffect, useState } from "react";
import styled from "styled-components";
import SubMenu from "./subMenu";
import { isMobile } from "../../globalStyles/mobile";
import { useLocation } from "react-router-dom";
import { useDarkMode } from "../context/darkModeContext";

const SidebarWrap = styled.div`
  width: 100%;
  height: calc(
    100vh - ${isMobile() ? 80 : 60}px
  ); /* Adjust height to be the total height minus the AppBar height */
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: ${isMobile() ? "4rem" : "0rem"};
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */

  &::-webkit-scrollbar {
    display: none; /* For Chrome, Safari, and Opera */
  }
`;

const Sidebar = ({ onClickSubMenu, onClickMenu, hideSideBar }) => {
  const { colors } = useDarkMode();
  const location = useLocation();
  const [activeSubMenuTitle, setActiveSubMenuTitle] = useState(null);
  const [sidemenuData, setSidemenuData] = useState([]);

  useEffect(() => {
    const loadSidemenu = () => {
      const resp = JSON.parse(localStorage.getItem("sidemenuItems") || "[]");
      setSidemenuData(resp);
    };
    loadSidemenu();
    window.addEventListener("sidemenu-updated", loadSidemenu);
    return () => window.removeEventListener("sidemenu-updated", loadSidemenu);
  }, []);

  useEffect(() => {
    localStorage.setItem("path", location.pathname);
    const resp = JSON.parse(localStorage.getItem("sidemenuItems") || "[]");
    setSidemenuData(resp);
  }, [location.pathname]);

  return (
    <div
      style={{
        background: colors.bgPaper,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        position: "fixed",
        left: 0,
        width: hideSideBar ? 79 : 200,
        transition: "350ms",
        zIndex: 10,
        color: colors.textPrimary,
      }}
    >
      {sidemenuData?.length ? (
        <SidebarWrap>
          {sidemenuData.map((item, index) => (
            <SubMenu
              hideSideBar={hideSideBar}
              onClickMenu={onClickMenu}
              onClickSubMenu={onClickSubMenu}
              item={item}
              key={item._id}
              activeSubMenuTitle={activeSubMenuTitle}
              setActiveSubMenuTitle={setActiveSubMenuTitle}
            />
          ))}
        </SidebarWrap>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Sidebar;
